/** Hash router: `#/path?a=1` — path and query live in `location.hash` after `#`. */

export function getFullHashWithoutSymbol(): string {
  return window.location.hash.replace(/^#/, '') || '/';
}

export function getHashPath(): string {
  const raw = getFullHashWithoutSymbol();
  const pathPart = raw.split('?')[0] || '/';
  const path = pathPart.startsWith('/') ? pathPart : `/${pathPart}`;
  return path === '/' ? '/dashboard' : path;
}

export function getHashSearchParams(): URLSearchParams {
  const raw = getFullHashWithoutSymbol();
  const qIndex = raw.indexOf('?');
  if (qIndex === -1) return new URLSearchParams();
  return new URLSearchParams(raw.slice(qIndex + 1));
}

/** A pasted/truncated percent escape must not crash the entire app router. */
export function decodeHashRouteParam(value: string | undefined): string | null {
  if (!value) return null;
  try { return decodeURIComponent(value); } catch { return null; }
}

const OAUTH_FEEDBACK_KEYS = ['error', 'connected', 'accountId'] as const;

/** Read OAuth callback flags once, then strip them so remounts do not toast again. */
export function consumeHashOAuthFeedback(): { error: string | null; connected: boolean } {
  const params = getHashSearchParams();
  const error = params.get('error');
  const connected = Boolean(params.get('connected'));
  const hasFeedback = OAUTH_FEEDBACK_KEYS.some((key) => params.has(key));
  if (!hasFeedback) return { error: null, connected: false };

  for (const key of OAUTH_FEEDBACK_KEYS) params.delete(key);
  const path = getHashPath();
  const qs = params.toString();
  const nextHash = qs ? `#${path}?${qs}` : `#${path}`;
  const nextUrl = `${window.location.pathname}${window.location.search}${nextHash}`;
  window.history.replaceState(null, '', nextUrl);
  return { error, connected };
}
